<template>
  <div class="fc-notification-form fc-notification-form--stack">
    <NotificationConfigureHeader
      :title="copy.title"
      :subtitle="copy.subtitle"
      kind="trigger"
      :icon="icon"
    />
    <NotificationNameField
      :value="name"
      :auto-name="autoName"
      :is-custom="nameIsCustom"
      :error="nameError"
      @input="name = $event"
      @update:isCustom="nameIsCustom = $event"
      @reset="resetName"
    />
    <p class="fc-notification-form__hint">{{ nameHint }}</p>
    <NotificationEnableRow
      v-model="flag"
      :hint="copy.enableHint"
      :disabled="disabled"
    />
    <div class="fc-notification-form__field fc-notification-form__field--chip-wrap">
      <span class="fc-notification-form__label">{{ locationLabel }}</span>
      <ChipMultiSelect
        v-model="selectedLocations"
        :items="locations"
        item-text="name"
        item-value="_id"
        outlined
        :error="locationsError"
        :disabled="disabled"
        data-testid="recon-change-form__locations"
        data-testid-prefix="recon-change-form__locations"
      />
    </div>
    <div class="fc-notification-form__field">
      <span class="fc-notification-form__label">{{ rolesLabel }}</span>
      <div class="fc-notification-form__roles">
        <v-checkbox
          v-for="role in roleOptions"
          :key="role.value"
          v-model="selectedRoles"
          :label="role.name"
          :value="role.value"
          color="primary"
          hide-details
          dense
          :disabled="disabled"
          :data-testid="`recon-change-form__role--${role.value}`"
        />
      </div>
      <p v-if="rolesError" class="fc-notification-form__error">{{ rolesError }}</p>
    </div>
    <div class="fc-notification-flow">
      <span class="fc-notification-chip fc-notification-chip--info">
        <v-icon x-small>mdi-upload-outline</v-icon>
        {{ copy.flowUpload }}
      </span>
      <span class="fc-notification-flow__or">or</span>
      <span class="fc-notification-chip fc-notification-chip--info">
        <v-icon x-small>mdi-sync</v-icon>
        {{ copy.flowSync }}
      </span>
      <v-icon x-small class="fc-notification-flow__arrow">mdi-chevron-right</v-icon>
      <span class="fc-notification-chip">{{ copy.flowChange }}</span>
      <v-icon x-small class="fc-notification-flow__arrow">mdi-chevron-right</v-icon>
      <span class="fc-notification-chip fc-notification-chip--success">
        <v-icon x-small>mdi-email-outline</v-icon>
        {{ copy.flowEmail }}
      </span>
    </div>
    <div class="fc-notification-infobox">
      <v-icon small>mdi-information-outline</v-icon>
      <p>{{ copy.info }}</p>
    </div>
  </div>
</template>

<script>
import ChipMultiSelect from '../../../../components/ChipMultiSelect/ChipMultiSelect.vue';
import {
  NotificationConfigureHeader,
  NotificationEnableRow,
  NotificationNameField,
} from '../../../../components/Notifications';
import {
  EMAIL_NOTIFICATION,
  NOTIFICATION_FEATURE_ICON,
  NOTIFICATION_FORM_COPY,
  NOTIFICATION_TYPE_KEYS,
} from '../../../../utils/constants';
import { buildNotificationName } from '../../../../utils/notificationNameUtils';
import notificationFormErrorMixin from './notificationFormErrorMixin';

export default {
  name: 'ReconChangeForm',
  components: {
    ChipMultiSelect,
    NotificationConfigureHeader,
    NotificationEnableRow,
    NotificationNameField,
  },
  mixins: [notificationFormErrorMixin],
  props: {
    value: { type: Object, default: () => ({}) },
    locations: { type: Array, default: () => [] },
    serverErrors: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      name: this.value.name || '',
      nameIsCustom: this.value.name_is_custom === true,
      flag: this.value.flag !== false,
      selectedLocations: [...(this.value.meta?.locations || [])],
      selectedRoles: [...(this.value.meta?.roles || [])],
      roleOptions: EMAIL_NOTIFICATION.roles,
      copy: NOTIFICATION_FORM_COPY.reconStatusChange,
      nameHint: NOTIFICATION_FORM_COPY.NAME_HINT,
      locationLabel: NOTIFICATION_FORM_COPY.LOCATION,
      rolesLabel: NOTIFICATION_FORM_COPY.ROLES,
      icon: NOTIFICATION_FEATURE_ICON.reconStatusChange,
    };
  },
  computed: {
    autoName() {
      return buildNotificationName(
        NOTIFICATION_TYPE_KEYS.RECON_STATUS_CHANGE,
        { locations: this.selectedLocations },
        this.locations
      );
    },
  },
  methods: {
    resetName() {
      this.nameIsCustom = false;
      this.name = this.autoName;
    },
    toPayload() {
      return {
        featureDetails: {
          _id: this.value._id,
          feature: NOTIFICATION_TYPE_KEYS.RECON_STATUS_CHANGE,
          flag: this.flag,
          name: this.nameIsCustom ? this.name : this.autoName,
          name_is_custom: this.nameIsCustom,
          meta: { locations: this.selectedLocations, roles: this.selectedRoles },
        },
      };
    },
  },
};
</script>
